import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { OfferDetailPageBody } from "../components/OfferDetailPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.OfferDetailPageTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <OfferDetailPageBody {...props} />
    </PageSkeleton>
);
